import { render } from "./DiasPreferenciaModal.vue?vue&type=template&id=6e6b4530&scoped=true"
import script from "./DiasPreferenciaModal.vue?vue&type=script&lang=js"
export * from "./DiasPreferenciaModal.vue?vue&type=script&lang=js"

import "./DiasPreferenciaModal.vue?vue&type=style&index=0&id=6e6b4530&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6b4530"]])

export default __exports__